import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.filter.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { lazyMethod, objectSpread, stringCamelCase } from '@polkadot/util';
import { lazyVariants } from "../../../create/lazy.js";
import { getSiName } from "../../util/index.js";
import { objectNameToCamel } from "../util.js";
import { createUnchecked } from "./createUnchecked.js";
export function filterCallsSome(_ref) {
  var calls = _ref.calls;
  return calls.isSome;
}
export function createCallFunction(registry, lookup, variant, sectionName, sectionIndex) {
  var fields = variant.fields,
      index = variant.index;
  var args = new Array(fields.length);

  for (var a = 0; a < fields.length; a++) {
    var _fields$a = fields[a],
        name = _fields$a.name,
        type = _fields$a.type,
        typeName = _fields$a.typeName;
    args[a] = objectSpread({
      name: stringCamelCase(name.unwrapOr("param".concat(a))),
      type: getSiName(lookup, type)
    }, typeName.isSome ? {
      typeName: typeName.unwrap()
    } : null);
  }

  return createUnchecked(registry, sectionName, new Uint8Array([sectionIndex, index.toNumber()]), registry.createTypeUnsafe('FunctionMetadataLatest', [objectSpread({
    args: args
  }, variant)]));
}
/** @internal */

export function decorateExtrinsics(registry, _ref2, version) {
  var lookup = _ref2.lookup,
      pallets = _ref2.pallets;
  var result = {};
  var filtered = pallets.filter(filterCallsSome);

  var _loop = function _loop(i) {
    var _filtered$i = filtered[i],
        calls = _filtered$i.calls,
        index = _filtered$i.index,
        name = _filtered$i.name;
    var sectionName = stringCamelCase(name);
    var sectionIndex = version >= 12 ? index.toNumber() : i;
    lazyMethod(result, sectionName, function () {
      return lazyVariants(lookup, calls.unwrap(), objectNameToCamel, function (variant) {
        return createCallFunction(registry, lookup, variant, sectionName, sectionIndex);
      });
    });
  };

  for (var i = 0; i < filtered.length; i++) {
    _loop(i);
  }

  return result;
}